export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const USER_NOTIFICATION_SETTINGS = "USER_NOTIFICATION_SETTINGS";
export const GET_USER_INFO_FAILED = "GET_USER_INFO_FAILED";